import { render, staticRenderFns } from "./LPCATResult.vue?vue&type=template&id=fff6a86c&scoped=true&"
import script from "./LPCATResult.vue?vue&type=script&lang=js&"
export * from "./LPCATResult.vue?vue&type=script&lang=js&"
import style0 from "./LPCATResult.vue?vue&type=style&index=0&id=fff6a86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff6a86c",
  null
  
)

export default component.exports